import { Chakra } from "@airhelp/react-ui-components";
import { ArrowRightIcon } from "styles/icons";
import type { PrevButtonProps } from "./PrevButton.d";

const { Button } = Chakra;

const PrevButton = ({ previousPage, canPreviousPage }: PrevButtonProps) => (
  <Button
    variant="unstyled"
    onClick={previousPage}
    disabled={!canPreviousPage}
    color="greyscale.600"
    d="flex"
    alignItems="center"
    sx={{ svg: { boxSize: 4 } }}
  >
    <ArrowRightIcon transform="rotate(180deg)" />
  </Button>
);

export default PrevButton;
